<template>
  <FormKit
    type="form"
    :value="{
            shopee_station_id:'',
            shopee_registered_different_agency:'',
        }"
    submit-label="Continuar"
    @submit="confirmData"
  >
    <h2 class="text-xl font-bold mb-1">Operação Shopee</h2>

    <FormKit
      type="select"
      name="shopee_station_id"
      label="Hub de atuação*"
      validation="required">
      <template v-for="hub in hubsList">
        <option :value="hub.station_id">{{ hub.station_name }}</option>
      </template>
    </FormKit>

    <FormKit
      type="select"
      name="shopee_registered_different_agency"
      label="Motivo do cadastro*"
      validation="required">
      <option value="false">Novo cadastro</option>
      <option value="true">Transferência de transportadora</option>
      </FormKit>

    <template #submit>
      <FooterButton>
      </FooterButton>
    </template>
  </FormKit>
</template>
<script>
import FooterButton from '../../components/FooterButton.vue'


import { useRouter } from 'vue-router'
import { useStore } from '@/stores/cadastro'
import { onMounted, ref } from 'vue'

export default {
  components: {
    FooterButton
  },

  setup(props) {
    const router = useRouter();
    const store = useStore();
    const hubsList = ref({});

    const shopee_station_id = ref('');
    const shopee_registered_different_agency = ref('');

    onMounted(async () => {
      await store.fetchHubs();
      hubsList.value = store.hubsList
    });

    onMounted(() => {
      const preRegistrationData = store.getRegistrationData;
      shopee_station_id.value = preRegistrationData.shopee_station_id;
      shopee_registered_different_agency.value = preRegistrationData.shopee_registered_different_agency;
    });

    const confirmData = async (formData) => {
        await store. updatePreRegistrationData(formData);
        router.push({ name: 'Password' });
    }

    return{
      hubsList,
      confirmData,
    }
  },
  methods: {
  }
}
</script>
